import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { myHeaders } from "./CommonHeader";

export const SendToCart = createAsyncThunk(
  "SendToCart",
  async (data1, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        process.env.REACT_APP_BackEndIP+"/AddToCart",
        {
          ID: data1,
        },
        {
          headers: myHeaders(),
        }
      );
      return data;
    } catch (error) {
      console.error("!!!", error);
      if (error?.response?.status > 399 || error.code === "ERR_NETWORK") {
        localStorage.clear();
        window.location.assign("/");
      }
    }
  }
);

const AddToCartSlice = createSlice({
  name: "AddToCart",
  initialState: {
    isLoading: false,
  },

  extraReducers: (builder) => {
    builder
      .addCase(SendToCart.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(SendToCart.pending, (state, action) => {
        state.isLoading = true;
      });
  },
});

export default AddToCartSlice.reducer;
